/* ==========================================================================
   DIREVULF — recent.js
   The "recently viewed" rail.

   The whole memory is a short list of product handles in this browser's own
   localStorage. It holds no identifier, no timestamp that leaves the device
   and no price — because every card is fetched back from Shopify when the rail
   is drawn, so what the shopper sees is the product AS IT IS NOW, not as it
   was when they looked.

   A handle that no longer resolves is dropped rather than drawn from memory,
   and with an empty list the whole section stays hidden. There is no fallback
   list of "popular" products: this store has no data that would make one true.
   ========================================================================== */
(function () {
  'use strict';

  var KEY = 'dv:recent';
  var MAX = 12;

  function $(sel, root) { return (root || document).querySelector(sel); }

  function read() {
    try {
      var raw = window.localStorage.getItem(KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list.filter(function (h) { return typeof h === 'string' && h; }) : [];
    } catch (e) { return []; }
  }

  function write(list) {
    try { window.localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX))); } catch (e) { /* private mode */ }
  }

  /* Most recent first, no duplicates. Called by product.js from the product
     page — this file is not loaded there, so the API is on window. */
  function record(handle) {
    if (!handle) return;
    var list = read().filter(function (h) { return h !== handle; });
    list.unshift(handle);
    write(list);
  }

  function clear() {
    try { window.localStorage.removeItem(KEY); } catch (e) { /* ignore */ }
  }

  window.DirevulfRecent = { list: read, record: record, clear: clear };

  function init() {
    /* data-dv-rvrail, not data-dv-recent: the search panel already owns
       data-dv-recent for its recent searches, and this file looks the whole
       document over rather than one panel. Sharing the name silently bound the
       rail to the search box — found on the storefront, not in review. */
    var root = $('[data-dv-rvrail]');
    if (!root) return;

    var grid = $('[data-dv-rv-grid]', root);
    var clearBtn = $('[data-dv-rv-clear]', root);
    var cardSection = root.getAttribute('data-card-section') || 'product-card-remote';
    var limit = parseInt(root.getAttribute('data-limit'), 10) || 4;

    /* Never show the product the shopper is already looking at. */
    var here = null;
    var host = $('[data-dv-product]');
    if (host) {
      var url = host.getAttribute('data-product-url') || '';
      var parts = url.split('/products/');
      if (parts.length > 1) here = parts[1].split('?')[0];
    }

    function fetchCard(handle) {
      var url = '/products/' + encodeURIComponent(handle) + '?section_id=' + encodeURIComponent(cardSection);
      return fetch(url, { headers: { Accept: 'text/html' } })
        .then(function (r) { return r.ok ? r.text() : null; })
        .catch(function () { return null; });
    }

    function load() {
      var handles = read().filter(function (h) { return h !== here; }).slice(0, limit);
      if (!handles.length) { root.hidden = true; return; }

      Promise.all(handles.map(fetchCard)).then(function (htmls) {
        if (!grid) return;
        grid.innerHTML = '';
        var kept = 0;
        var alive = [];

        htmls.forEach(function (html, i) {
          if (!html) return; /* gone from the storefront — forget it */
          var holder = document.createElement('div');
          holder.innerHTML = html;
          var card = holder.querySelector('[data-dv-product-card]');
          if (!card) return;
          var li = document.createElement('li');
          li.appendChild(card);
          grid.appendChild(li);
          alive.push(handles[i]);
          kept += 1;
        });

        /* Drop anything that did not come back, so the list heals itself. */
        if (alive.length !== handles.length) {
          var rest = read().filter(function (h) {
            return alive.indexOf(h) > -1 || handles.indexOf(h) === -1;
          });
          write(rest);
        }

        root.hidden = kept === 0;
        if (kept) document.dispatchEvent(new CustomEvent('dv:section:loaded'));
      });
    }

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        clear();
        if (grid) grid.innerHTML = '';
        root.hidden = true;
      });
    }

    load();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
